import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastService } from './toast.service';
import { IASMModel } from '../shared/models/asm.model';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { IResponse } from '../shared/models/IResponse.model';

@Injectable({
  providedIn: 'root'
})
export class AcarsService {

  constructor(private httpClient: HttpClient, private toastService: ToastService) { }

  uploadACARS(acarsModel: IASMModel): Observable<boolean> {
    return this.httpClient.post(`${environment.api_base_url}acars/upload`, acarsModel, {}).pipe(
      map((item: IResponse<boolean>) => {
        if(item?.isError){
          console.log(item.message);
        }
        return item?.data || null;
      }),
      catchError(() => {
        this.toastService.showError("Error uploading ACARS file");
        return of(null);
      })
    );
  }
}
